<template>
    <div>
        <div class="mb-2 fw-bold">
            {{ tagListLabel }}
        </div>
        <ul
            v-if="tagCount > 0 && !referToDataFieldGroupsTab && !showTagsNotSupported"
            class="no-bullets short-indent">
            <li
                v-for="tag in tagTexts"
                v-bind:key="tag">
                <!-- Using white-space: pre; don't add whitespace to template-->
                <pc-copyable v-bind:copy-string="getTemplateTagWithoutDescription(tag)">
                    <span style="white-space: pre">{{ tag }}</span>
                </pc-copyable>
            </li>
            <li v-if="showDeadlineTemplateTagSupportLink">
                <a
                    v-bind:href="deadlineTemplateTagSupportUrl"
                    target="_blank">
                    {{ deadlineTemplateTagsSupportLinkText }}
                </a>
            </li>
        </ul>
        <div
            v-if="referToDataFieldGroupsTab"
            class="fst-italic">
            {{ tagsOnDataFieldGroup }}
        </div>
        <div
            v-if="referToDataFieldsTab"
            class="fst-italic">
            {{ customListGroupTagsText }}
        </div>
        <div
            v-if="showTagsNotSupported"
            class="fst-italic">
            {{ tagsNotSupportedText }}
        </div>
    </div>
</template>
<script>
    import { KEYS, NAMESPACE } from "./i18n/tagList.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        props: {
            // Should be a string array
            tagTexts: { type: Array, required: false, default: () => [] },
            dataFieldGroupName: { type: String, required: false, default: null },
            showSeeDataFields: { type: Boolean, required: false, default: false },
            showTagsNotSupported: { type: Boolean, required: false, default: false },
            showDeadlineTemplateTagSupportLink: { type: Boolean, required: false, default: false }
        },
        computed: {
            tagCount() {
                return this.tagTexts.length;
            },
            referToDataFieldGroupsTab() {
                return this.dataFieldGroupName && this.dataFieldGroupName.length > 0;
            },
            referToDataFieldsTab() {
                return this.showSeeDataFields;
            },
            deadlineTemplateTagSupportUrl() {
                return "https://support.cleanpower.com/powerclerk/deadlines/#dct_deadlines";
            },
            ...mapI18n(
                {
                    ...KEYS,
                    tagListLabel() {
                        return {
                            key: KEYS.tagListLabel,
                            count: this.tagCount
                        };
                    },
                    tagsOnDataFieldGroup() {
                        return {
                            key: KEYS.tagsOnDataFieldGroup,
                            values: { dataFieldGroupName: this.dataFieldGroupName }
                        };
                    }
                },
                NAMESPACE
            )
        },
        methods: {
            getTemplateTagWithoutDescription(tag) {
                const startTag = tag.indexOf("{");
                const endTag = tag.indexOf("}");
                return tag.slice(startTag, endTag + 1);
            }
        }
    };
</script>
